<template>
  <div class="container">
    <div class="row h-50">
      <div
        v-if="loading"
        class="row d-flex justify-content-center align-middle my-4"
      >
        <h3>Loading magical things :)</h3>
      </div>
      <div class="col-8 offset-2 my-4" v-else>
        <h2 class="message">Enter your Asset Manufacturing ID</h2>
        <p>
          <label class="message" for="assetMfgId">Asset Mfg Id (Length: {{assetMfgId.length}})</label>
          <input
            class="form-control my-2"
            id="assetMfgId"
            v-model="assetMfgId"
            type="text"
            name="assetMfgId"
            maxlength="32"
          />
          <p>Asset Mfg Id Line 1: {{ aId1 }}</p>
          <p>Asset Mfg Id Line 2: {{ aId2 }}</p>
          <p>Asset Mfg Id Binary Line 1: {{ aId1Binary }}</p>
          <p>Asset Mfg Id Binary Line 2: {{ aId2Binary }}</p>
          <label class="message" for="bleserone">BLE Serial Row 1 (Length: {{bleseroneCount}})</label>
          <input
            class="form-control my-2"
            id="bleserone"
            v-model="bleserone"
            type="text"
            name="bleserone"
          />
          <p>Serial 1 Hex: {{bleseroneHex}}</p>
          <label class="message" for="blesertwo">BLE Serial Row 2 (Length: {{blesertwoCount}})</label>
          <input
            class="form-control my-2"
            id="blesertwo"
            v-model="blesertwo"
            type="text"
            name="blesertwo"
          />
          <p>Serial 2 Hex: {{blesertwoHex}}</p>
          <label class="message" for="bleserone">BLE Serial Row 3 (Length: {{bleserthreeCount}})</label>
          <input
            class="form-control my-2"
            id="bleserthree"
            v-model="bleserthree"
            type="text"
            name="bleserthree"
          />
          <p>Serial 3 Hex: {{bleserthreeHex}}</p>
          <label class="message" for="bleserfour">BLE Serial Row 4 (Length: {{bleserfourCount}})</label>
          <input
            class="form-control my-2"
            id="bleserfour"
            v-model="bleserfour"
            type="text"
            name="bleserfour"
          />
          <p>Serial 4 Hex: {{bleserfourHex}}</p>
          <label class="message" for="bleserfive">BLE Serial Row 5 (Length: {{bleserfiveCount}})</label>
          <input
            class="form-control my-2"
            id="bleserfive"
            v-model="bleserfive"
            type="text"
            name="bleserfive"
          />
          <p>Serial 5 Hex: {{bleserfiveHex}}</p>
       </p>
        <div class="py-3" style="text-align: center">
          <button class="ty-button" v-on:click="splitAssetMfgId">
            Split Asset Mfg Id
          </button>
        </div>
        <div class="py-3" style="text-align: center">
          <button class="ty-button" v-on:click="assetsToBinary">
            Assets To Binary
          </button>
        </div>
        <div class="py-3" style="text-align: center">
          <button class="ty-button" v-on:click="generateBleSerial">
            Generate Ble Serial
          </button>
        </div>
        <div class="py-3" style="text-align: center">
          <button class="ty-button" v-on:click="generateBleSerialHex">
            Generate Ble Serial Hex
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BigNumber from "bignumber.js";
import { analytics } from "../../config/firebaseInit";

export default {
  name: "dkassetserial",
  data: function () {
    return {
      bleserone: "",
      blesertwo: "",
      bleserthree: "",
      bleserfour: "",
      bleserfive: "",
      bleseroneCount: 0,
      blesertwoCount: 0,
      bleserthreeCount: 0,
      bleserfourCount: 0,
      bleserfiveCount: 0,
      assetMfgId: "",
      loading: false,
      aId1: "",
      aId2: "",
      aId1Binary: "",
      aId2Binary: "",
      bleseroneHex: "",
      blesertwoHex: "",
      bleserthreeHex: "",
      bleserfourHex: "8000000000000000",
      bleserfiveHex: "A000000000000000",
    };
  },
  created() {
    analytics.logEvent("dk-asset-to-serial");
  },
  methods: {
    generateBleSerial: function () {
      const aId1LessThree = this.aId1Binary.substr(0, 61);
      this.bleserone = `001${aId1LessThree}`;
      this.bleseroneCount = this.bleserone.length;
      const aId2LessThreeA = this.aId1Binary.substr(61, 64);
      const aId2LessThreeB = this.aId2Binary.substr(0, 58);
      const aId2LessThree = `${aId2LessThreeA}${aId2LessThreeB}`;
      this.blesertwo = "010" + aId2LessThree;
      this.blesertwoCount = this.blesertwo.length;
      let aId3Less = this.aId2Binary.substr(58, 6);
      while (aId3Less.length < 61) {
        aId3Less = aId3Less + "0";
      }
      this.bleserthree = "011" + aId3Less;
      this.bleserthreeCount = this.bleserthree.length;
      let aId4Less = "0";
      while (aId4Less.length < 64) {
        aId4Less = aId4Less + "0";
      }
      this.bleserfour = aId4Less;
      let aId5Less = "0";
      while (aId5Less.length < 64) {
        aId5Less = aId5Less + "0";
      }
      this.bleserfive = aId4Less;
    },
    generateBleSerialHex: function () {
      this.bleseroneHex = BigNumber(this.bleserone, 2)
        .toString(16)
        .toUpperCase();
      this.blesertwoHex = BigNumber(this.blesertwo, 2)
        .toString(16)
        .toUpperCase();
      this.bleserthreeHex = BigNumber(this.bleserthree, 2)
        .toString(16)
        .toUpperCase();
    },
    splitAssetMfgId: function () {
      this.aId1 = this.assetMfgId.substr(0, 16);
      this.aId2 = this.assetMfgId.substr(16, 16);
    },
    assetsToBinary: function () {
      this.aId1Binary = this.hex2bin(this.aId1);
      this.aId2Binary = this.hex2bin(this.aId2);
    },
    hex2bin: function (hex) {
      return BigNumber(hex, 16)
        .toString(2)
        .padStart(4 * hex.length, "0");
    },
    removeThreeBits: function (binaryString) {
      const substring = binaryString.slice(3);
      // console.log(substring);
      return substring;
    },
    generateRandomINT_MVK: function () {
      const len = 32;
      const c = "ABCDEF0123456789";
      const clen = c.length;
      let ret = "";

      for (let i = 0; i < len; i++) {
        ret += c[Math.floor(Math.random() * clen)];
      }
      this.encryptedVehicleKey = ret;
      return ret;
    },
  },
};
</script>

<style>
.ty-button {
  background: #d92429;
  border-radius: 28px;
  width: 320px;
  height: 56px;
  font-family: ToyotaType-Semibold;
  font-size: 24px;
  color: #ffffff;
  letter-spacing: 0.73px;
  text-align: center;
}
</style>
